export default __webpack_public_path__ + "static/media/optimism-logo.aa4efe4f.svg";